<template>
  <div class="flex">
    <Combobox
      @update:open="isOpen = $event"
      :type="type"
      :groups="[
        {
          options: sortOptions,
        },
      ]"
    >
      <template #trigger>
        <Tooltip
          :title="$t('components.tooltips.sort_by')"
          side="bottom"
          disableHoverableContent
        >
          <Button
            icon
            size="xs"
            variant="tertiary"
            type="gray"
            :disabled="disabled"
            :class="{
              'bg-utility-brand-50_alt fg-brand-primary_alt': isOpen,
            }"
            data-id="header.sorting"
          >
            <template #start>
              <Icon name="swap" />
            </template>
          </Button>
        </Tooltip>
      </template>
    </Combobox>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Icon } from "@/SharedComponents/Icon";
import { Combobox } from "@/SharedComponents/Sorting/Combobox";
import { Button } from "@/SharedComponents/Buttons";
import { Tooltip } from "@/SharedComponents/Tooltips";

import { useSortOptions } from "@/SharedComponents/Sorting";

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const isOpen = ref(false);
const { sortOptions } = useSortOptions(props.type);
</script>
